import { ballArr, count, singleDouble, smallBig, dragonTiger } from '../resPatterns.js';

const ssc = {
  0: {
    single: [],
    double: [],
    big: [],
    small: []
  },
  1: {
    single: [],
    double: [],
    big: [],
    small: []
  },
  2: {
    single: [],
    double: [],
    big: [],
    small: []
  },
  3: {
    single: [],
    double: [],
    big: [],
    small: []
  },
  4: {
    single: [],
    double: [],
    big: [],
    small: []
  },
  5: {
    single: [],
    double: [],
    big: [],
    small: []
  }
};

const sscformatPattern = x =>
  ({
    single: '单',
    double: '双',
    big: '大',
    small: '小'
  }[x]);

const sscformatRank = x =>
  ({
    '0': '总和',
    '1': '第一球',
    '2': '第二球',
    '3': '第三球',
    '4': '第四球',
    '5': '第五球'
  }[x]);

const getSScLongQueueContinue = (list, he) => {
  let initData = Object.assign({}, ssc);
  if (list.length == 0) {
    return [];
  }

  let handleList = list.reduce((a, b) => {
    let balls = b.resultStr.split(',').map(x => Number(x));
    // console.log('balls', balls);
    let rescount = count(balls);
    // console.log('total', rescount);
    let arr = [rescount, ...balls];
    // console.log('arr', arr);
    arr.map((x, i) => {
      let bigKey = 9;
      if (i == 0) {
        bigKey = 45;
        if (he) {
          bigKey = 60;
        }
      }

      a[i].big.push(smallBig(x, bigKey) == 1 ? x : null);
      a[i].small.push(smallBig(x, bigKey) == 0 ? x : null);
      a[i].single.push(singleDouble(x) == 0 ? x : null);
      a[i].double.push(singleDouble(x) == 1 ? x : null);
    });
    return a;
  }, initData);

  let continueObj = Object.keys(handleList).reduce((a, b) => {
    let key = b;
    a[key] = {};
    a[key].big = getContinue(handleList[b].big);
    a[key].small = getContinue(handleList[b].small);
    a[key].single = getContinue(handleList[b].single);
    a[key].double = getContinue(handleList[b].double);
    return a;
  }, {});
  console.log('contiu', continueObj);
  return Object.entries(continueObj)
    .reduce((a, b) => {
      let key = sscformatRank(b[0]);
      Object.keys(b[1]).map(x => {
        if (b[1][x] >= 2) {
          let obj = {
            name: key,
            type: sscformatPattern(x),
            value: b[1][x]
          };
          a.push(obj);
        }
      });
      return a;
    }, [])
    .sort((a, b) => b.value - a.value);
};

const getContinue = list => {
  let count = 0;
  for (let i = 0; i < list.length; i++) {
    if (list[i] == null) {
      break;
    } else {
      count++;
    }
  }
  return count;
};

const pk10formatName = x =>
  ({
    gyh: '冠亚和',
    '0': '冠军',
    '1': '亚军',
    '2': '第三名',
    '3': '第四名',
    '4': '第五名',
    '5': '第六名',
    '6': '第七名',
    '7': '第八名',
    '8': '第九名',
    '9': '第十名'
  }[x]);
const pk10formatType = x =>
  ({
    single: '单',
    double: '双',
    big: '大',
    small: '小',
    dragon: '龙',
    tiger: '虎'
  }[x]);

const getpk10LongQueueContinue = list => {
  let initData = {};
  if (list.length == 0) {
    return [];
  }

  let handleList = list.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    let gyh = arr[0] + arr[1];

    if (!a['gyh']) {
      a['gyh'] = {
        single: [],
        double: [],
        big: [],
        small: [],
        dragon: [],
        tiger: []
      };
    }
    a['gyh'].single.push(singleDouble(gyh) == 0 ? gyh : null);
    a['gyh'].double.push(singleDouble(gyh) == 1 ? gyh : null);
    a['gyh'].big.push(smallBig(gyh, 20) == 1 ? gyh : null);
    a['gyh'].small.push(smallBig(gyh, 20) == 0 ? gyh : null);

    arr.map((x, i) => {
      if (!a[i]) {
        a[i] = {
          single: [],
          double: [],
          big: [],
          small: [],
          dragon: [],
          tiger: []
        };
      }
      a[i].big.push(smallBig(x, 10) == 1 ? x : null);
      a[i].small.push(smallBig(x, 10) == 0 ? x : null);
      a[i].single.push(singleDouble(x) == 0 ? x : null);
      a[i].double.push(singleDouble(x) == 1 ? x : null);
      if (i < 5) {
        a[i].dragon.push(dragonTiger(x, arr[9 - i]) == 0 ? x : null);
        a[i].tiger.push(dragonTiger(x, arr[9 - i]) == 1 ? x : null);
      }
    });
    return a;
  }, {});

  let continueObj = Object.keys(handleList).reduce((a, b) => {
    let key = b;
    a[key] = {};
    a[key].big = getContinue(handleList[b].big);
    a[key].small = getContinue(handleList[b].small);
    a[key].single = getContinue(handleList[b].single);
    a[key].double = getContinue(handleList[b].double);
    a[key].dragon = getContinue(handleList[b].dragon);
    a[key].tiger = getContinue(handleList[b].tiger);
    return a;
  }, []);

  return Object.entries(continueObj)
    .reduce((a, b) => {
      let key = pk10formatName(b[0]);
      Object.keys(b[1]).map(x => {
        if (b[1][x] >= 2) {
          let obj = {
            name: key,
            type: pk10formatType(x),
            value: b[1][x]
          };
          a.push(obj);
        }
      });

      return a;
    }, [])
    .sort((a, b) => b.value - a.value);
};

const hptenformatName = x =>
  ({
    '0': '第一球',
    '1': '第二球',
    '2': '第三球',
    '3': '第四球',
    '4': '第五球',
    '5': '第六球',
    '6': '第七球',
    '7': '第八球'
  }[x]);
const hptenformatType = x =>
  ({
    single: '单',
    double: '双',
    big: '大',
    small: '小',
    dragon: '龙',
    tiger: '虎'
  }[x]);

const gehptenLongQueueContinue = list => {
  let initData = {};
  if (list.length == 0) {
    return [];
  }

  let handleList = list.reduce((a, b) => {
    let arr = ballArr(b.resultStr);

    arr.map((x, i) => {
      if (!a[i]) {
        a[i] = {
          single: [],
          double: [],
          big: [],
          small: [],
          dragon: [],
          tiger: []
        };
      }
      a[i].big.push(smallBig(x, 20) == 1 ? x : null);
      a[i].small.push(smallBig(x, 20) == 0 ? x : null);
      a[i].single.push(singleDouble(x) == 0 ? x : null);
      a[i].double.push(singleDouble(x) == 1 ? x : null);
      if (i < 4) {
        a[i].dragon.push(dragonTiger(x, arr[7 - i]) == 0 ? x : null);
        a[i].tiger.push(dragonTiger(x, arr[7 - i]) == 1 ? x : null);
      }
    });
    return a;
  }, {});

  let continueObj = Object.keys(handleList).reduce((a, b) => {
    let key = b;
    a[key] = {};
    a[key].big = getContinue(handleList[b].big);
    a[key].small = getContinue(handleList[b].small);
    a[key].single = getContinue(handleList[b].single);
    a[key].double = getContinue(handleList[b].double);
    a[key].dragon = getContinue(handleList[b].dragon);
    a[key].tiger = getContinue(handleList[b].tiger);
    return a;
  }, []);

  return Object.entries(continueObj)
    .reduce((a, b) => {
      let key = hptenformatName(b[0]);
      Object.keys(b[1]).map(x => {
        if (b[1][x] >= 2) {
          let obj = {
            name: key,
            type: hptenformatType(x),
            value: b[1][x]
          };
          a.push(obj);
        }
      });

      return a;
    }, [])
    .sort((a, b) => b.value - a.value);
};

export default (type, list) => {
  if (type == 'ssc') {
    return getSScLongQueueContinue(list);
  }
  if (type == 'PK10' || type == 'nn') {
    return getpk10LongQueueContinue(list);
  }
  if (type == 'hpten') {
    return gehptenLongQueueContinue(list);
  }
  if (type == 'choose5') {
    return getSScLongQueueContinue(list, 30);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/statistic/getLongQueueContinue.js